<template>
    <AppPage title="Produtos" subtitle="Gerenciar produtos">

        <div class="actions" slot="actions">
            <b-button type="is-primary" @click="executeAction('create', null)" rounded>Adicionar</b-button>
        </div>

        <div class="products-list">
            <table class="table is-fullwidth is-striped is-hoverable is-middle">
                <thead>
                <tr>
                    <th width="60">Imagem</th>
                    <th>Nome</th>
                    <th class="is-hidden-touch">Valor</th>
                    <th class="is-hidden-touch">Unidade</th>
                    <th width="50">Estoque</th>
                    <th width="20" class="is-hidden-touch">Ativo</th>
                    <th width="10"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="product in products" :key="product.id">
                    <td><product-image :product="product.data" /></td>
                    <td>
                        {{ product.data.name }}
                        <div class="is-small has-text-grey">{{ product.data.code }}</div>
                    </td>
                    <td class="is-hidden-touch">{{ product.data.price | money }}</td>
                    <td class="is-hidden-touch">{{ product.data.measureUnit }}</td>
                    <td>
                        <b-tag :type="product.data.stock <= 0 ? 'is-danger' : 'is-default'" rounded>
                            <convertUnit :value="product.data.stock" :current-unit="product.data.measureUnit" />
                        </b-tag>
                    </td>
                    <td class="is-hidden-touch">
                        <b-tag type="is-success" v-if="product.data.active" rounded>Ativo</b-tag>
                        <b-tag rounded v-else>Inativo</b-tag>
                    </td>
                    <td>
                        <b-dropdown aria-role="list" position="is-bottom-left">
                            <button class="button is-text" slot="trigger" slot-scope="{ active }">
                                <b-icon :icon="active ? 'angle-up' : 'angle-down'"></b-icon>
                            </button>

                            <b-dropdown-item aria-role="listitem" @click="executeAction('edit', product.id)">Editar</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="executeAction('duplicate', product.id)">Duplicar</b-dropdown-item>
                            <hr class="dropdown-divider">
                            <b-dropdown-item aria-role="listitem" @click="executeAction('remove', product.id)">Apagar</b-dropdown-item>
                        </b-dropdown>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </AppPage>
</template>

<script>
    import AppPage from "@/components/AppPage";
    import convertUnit from "./convertUnit";
    import firebase from '@/services/firebase';
    import {edit, remove, duplicate, create} from '../produts.actions';
    import ProductImage from "@/modules/products/components/ProductImage";
        
    const actions = {create, edit, remove, duplicate};
    const db = firebase.firestore();

    export default {
        name: "listProducts",
        components: {ProductImage, AppPage, convertUnit},

        data() {
            return {
                products: []
            }
        },

        methods: {
            executeAction(action, parameter){
                const actionExecute = actions[action];
                if(actionExecute){
                    actionExecute(parameter);
                }
            }
        },
        
        created() {
            
            let loading = this.$buefy.loading.open();
            
            this._unsubscriveProductsSnapshots = db.collection('products')
                .orderBy('name')
                .onSnapshot((spapshot) => {
                    const products = []
                    spapshot.forEach(document => {
                        products.push({
                            id: document.id,
                            data: document.data()
                        });
                    });
                    
                    this.products = products;
    
                    if(loading){
                        loading.close();
                    }
                })
        },
        
        beforeDestroy() {
            if(this._unsubscriveProductsSnapshots){
                this._unsubscriveProductsSnapshots();
            }
        }
    }
</script>
